// extracted by mini-css-extract-plugin
export default {"container":"fk9gV","container__price":"yNoPQ"};